
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import { TDashboardRegionFilterFullFilter } from '../../../types/regionDashboards';
  import DashboardsYearFilterBlock from '../DashboardsYearFilterBlock.vue';
  import RegionDashboardsExportButtons from './RegionDashboardsExportButtons.vue';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'RegionDashboardsAdditionFilterBlock',
    components: {
      DashboardsYearFilterBlock,
      RegionDashboardsExportButtons,
      InputBlock,
      SelectMultiComponent,
    },
    emits: {
      changeFilter: (value: Partial<TDashboardRegionFilterFullFilter>) => value,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionFilterFullFilter>,
        required: true,
      },
    },
    created() {
      this.getPartnerCountrySearchId();
    },
    computed: {
      ...mapGetters({
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
      }),
    },
    methods: {
      ...mapActions({
        getPartnerCountrySearchId: DIRECTIVES_ACTIONS_NAME.getPartnerCountrySearchId,
      }),
      changeFilter(filter: Partial<TDashboardRegionFilterFullFilter>) {
        this.$emit('changeFilter', { ...this.filter, ...filter });
      },
      updateCountryId(countryId: number) {
        this.changeFilter({ countryId });
      },
    },
  });
